import HttpAuthApi from './http/HttpAuthApi';

function getAuthApi() {
  if (process.env.REACT_APP_AUTH_API_URL) {
    return new HttpAuthApi();
  }
  throw new Error(
    "No authentication api url specified. Use env property 'REACT_APP_AUTH_API_URL' to define it."
  );
}

export default getAuthApi();
